var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"label":"","outlined":"","color":_vm.colorScheme,"small":""}},[_vm._v(" "+_vm._s(_vm.scheduleSystem)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }